export const contractCheckout = {
  'Card number': 'Numero de la tarjeta',
  'Name printed on card': 'Nombre impreso en la tarjeta',
  'Choose your payment method, {{name}}': 'Elige su método de pago, {{name}}',
  Credit: 'Crédito',
  CVC: 'Código de Seguridad',
  'Expiry date': 'Fecha de vencimiento',
  Installments: 'Cuotas',
  main: 'principal',
  'Make payment': 'Hacer el pago',
  'New card': 'Nueva tarjeta',
  'New credit card': 'Nueva tarjeta de crédito',
  'Pay with {{flag}}': 'Pagar con {{flag}}',
  'Pending issues successfully paid!': 'Asuntos pendientes pagados con éxito!',
  'Select the credit card': 'Selecciona la tarjeta de crédito',
  'Main card of the contract': 'Tarjeta principal del contrato',
  'The new card will be charged first in the next installments The current card remains linked and will be tried if the charge on the new card is not approved':
    'Las próximas cuotas se cobrarán primero en la nueva tarjeta. La tarjeta actual sigue vinculada y se intentará si el cobro en la nueva tarjeta no es aprobado.',
  'Your current card remains as the main payment method The new card will be tried only when the charge on the main card is not approved':
    'Tu tarjeta actual sigue como método principal. La nueva tarjeta se intentará solo cuando el cobro en la tarjeta principal no sea aprobado.',
  'I authorize linking this card to my contract as the main payment method for the next installments':
    'Autorizo vincular esta tarjeta a mi contrato como método de pago principal de las próximas cuotas.',
  'I authorize linking this card to my contract as a secondary payment method, to be charged when the main card is not approved':
    'Autorizo vincular esta tarjeta a mi contrato como método de pago secundario, para ser cobrada cuando la tarjeta principal no sea aprobada.',
  'Payment not approved': 'Pago no aprobado',
  'Your payment was not approved You can try again with the same card or choose another one':
    'Tu pago no fue aprobado. Puedes intentarlo nuevamente con la misma tarjeta o elegir otra.',
  'Try again': 'Intentar nuevamente',
};
